import { createContext } from 'react'
import { EventsData } from './types'
import { Moment } from 'moment'

export type CalendarContext = {
  readonly?: boolean
  data: EventsData
  currentDate: Date
  setCurrentDate: (date: Moment) => void
  currentMonth: number
  setCurrentMonth: (number: number) => void
  currentYear: number
  setCurrentYear: (number: number) => void
  colors: number[]
  onDataChange?: (events: EventsData) => void
  showEventPopup?: boolean
} | null

export const EventCalendarContext = createContext<CalendarContext>(null)
